import React, { useState } from 'react';
import styled from 'styled-components';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
  icon?: React.ReactNode;
  onIconClick?: () => void;
}

const InputContainer = styled.div<{ $fullWidth: boolean }>`
  position: relative;
  width: ${props => (props.$fullWidth ? '100%' : 'auto')};
`;

const InputLabel = styled.label`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.14;
  color: #609F94;
  margin-bottom: 4px;
  display: block;
`;

const StyledInput = styled.input`
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #284640;
  border-radius: 0;
  padding: 8px 0;
  color: #FFFFFF;
  font-size: 16px;
  font-family: 'Ubuntu', sans-serif;
  
  &::placeholder {
    color: #609F94;
  }
  
  &:focus {
    outline: none;
    border-color: #24B97D;
  }
`;

const IconContainer = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #609F94;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  color: #D85355;
  margin-top: 4px;
`;

const FormInput: React.FC<FormInputProps> = ({
  label,
  error,
  fullWidth = true,
  icon,
  onIconClick,
  ...rest
}) => {
  return (
    <div>
      {label && <InputLabel>{label}</InputLabel>}
      <InputContainer $fullWidth={fullWidth}>
        <StyledInput {...rest} />
        {icon && (
          <IconContainer onClick={onIconClick}>
            {icon}
          </IconContainer>
        )}
      </InputContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default FormInput; 